import styled from 'styled-components';

export const StyledEnvironmentHistory = styled.div`
  .eh-wrapper {
    padding: 0 24px;

    &-top {
      padding: 15px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-box {
        display: flex;
        align-items: center;
        gap: 12px;

        &-label {
          color: #2f2f35;
        }

        &-select {
          display: flex;
          align-items: center;
          gap: 16px;

          > div {
            margin: 0 !important;

            .MuiSelect-select {
              width: 136px;
            }
          }

          &.flex {
            display: flex;
            align-items: center;
            gap: 12px;
          }
        }
      }
    }
  }
`;
